const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL || '/api'}/user`;

class UsersAPI {
  // Authentication methods
  async signup(email, password) {
    const response = await fetch(`${API_BASE_URL}/signup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Signup failed');
    }
    
    return response.json();
  }
  
  async login(email, password) {
    const response = await fetch(`${API_BASE_URL}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Login failed');
    }
    
    return response.json();
  }

  // User CRUD operations
  async createUser(email, password) {
    const response = await fetch(`${API_BASE_URL}/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'User creation failed');
    }
    
    return response.json();
  }

  async getAllUsers(limit = 100, offset = 0) {
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString()
    });
    
    const response = await fetch(`${API_BASE_URL}/?${params}`);
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch users');
    }
    
    return response.json();
  }

  async getUserById(userId) {
    const response = await fetch(`${API_BASE_URL}/${userId}`);
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch user');
    }
    
    return response.json();
  }

  async getUserByEmail(email) {
    const response = await fetch(`${API_BASE_URL}/email/${email}`);
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch user');
    }
    
    return response.json();
  }

  async updateUser(userId, userData) {
    const response = await fetch(`${API_BASE_URL}/${userId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userData)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Update failed');
    }
    
    return response.json();
  }

  async deleteUser(userId) {
    const response = await fetch(`${API_BASE_URL}/${userId}`, {
      method: 'DELETE'
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Delete failed');
    }
    
    return response.ok;
  }

  // Helper method to get current user from localStorage
  getCurrentUser() {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        return JSON.parse(storedUser);
      } catch (error) {
        console.error('Error parsing stored user data:', error);
        localStorage.removeItem('user');
        return null;
      }
    }
    return null;
  }

  // Helper method to get current user ID
  getCurrentUserId() {
    const user = this.getCurrentUser();
    return user ? user.id : null;
  }
}

export default new UsersAPI();
